import { HttpContextToken } from '@angular/common/http';

/**
 * Pins which mailbox a request acts on, instead of letting the interceptor read
 * the live one.
 *
 * `EmailImpersonationInterceptor` normally stamps `X-Impersonate-User-Id` from
 * `EmailImpersonationService.targetId` **at request time**, which is right for
 * every request the user is waiting on: it is issued and answered while they are
 * still looking at the mailbox they issued it from.
 *
 * Undo Send breaks that assumption. The send is built when the user clicks Send
 * and dispatched thirty seconds later, and the mailbox can change in between —
 * so an unpinned request would be stamped with whichever rep the owner happens
 * to be looking at when the timer fires, and the message would go out from the
 * wrong mailbox. That is a data-integrity failure, not a UX wrinkle, so the
 * outbox captures the target at queue time and replays it here. The post-send
 * draft delete needs it just as much: the same id in the wrong mailbox is a 404
 * at best and somebody else's draft at worst.
 *
 * Three states, and the distinction between the last two matters:
 *  - `undefined` — not pinned; use the live service value (every existing caller)
 *  - `null`      — pinned to the owner's OWN mailbox; send no header
 *  - a number    — pinned to that user's mailbox
 */
export const IMPERSONATE_AS = new HttpContextToken<number | null | undefined>(() => undefined);
